<template>
  <div style="clear: both">
    <v-card :color="backgroundColor">
      <template v-if="!readonly || (readonly && formStatusChangeFullyImplemented && isFacilitator)">
        <v-toolbar elevation="8" density="compact" :color="backgroundColor">
          <v-toolbar-title>{{ $t('Facilitator_Actions') }}</v-toolbar-title>
          
        </v-toolbar>
      </template>
      <v-container fluid>
        <template v-if="(formStatusNew || formStatusDraft || formStatusSubmitted) && readonly">
          <v-row>
            <v-col cols="12" sm="6">
              <people-picker
                :label="$t('Facilitator')"
                :user="moc.roles.facilitator"
                :inUser="moc.roles.facilitator"
                readonly
              ></people-picker>
            </v-col>

            <v-col cols="12" sm="6">
              <people-picker
                :label="$t('Facilitator_Backup')"
                :user="moc.roles.facilitatorBackup"
                :inUser="moc.roles.facilitatorBackup"
                readonly
              ></people-picker>
            </v-col>
          </v-row>
        </template>

        <template
          v-if="
            readonly &&
            !formStatusNew &&
            !formStatusDraft &&
            !formStatusSubmitted &&
            !formStatusSentBack &&
            !formStatusChangeFullyImplemented
          "
        >
          <v-row>
            <v-col cols="12" sm="10" v-if="moc.approvalProcessType && moc.approvalProcessType.name">
              <v-text-field v-model="moc.approvalProcessType.name" :label="$t('Approval_Process_Type')" readonly></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              
              <people-picker
                :label="$t('Owner')"
                :user="moc.roles.owner"
                :inUser="moc.roles.owner"
                :readonly="true"
              ></people-picker>
            </v-col>

            <v-col cols="12" sm="6">
              <people-picker
                :label="$t('Coordinator')"
                :user="moc.roles.coordinator"
                :inUser="moc.roles.coordinator"
                readonly
              ></people-picker>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <people-picker
                :label="$t('Facilitator')"
                :user="moc.roles.facilitator"
                :inUser="moc.roles.facilitator"
                readonly
              ></people-picker>
            </v-col>

            <v-col cols="12" sm="6">
              <people-picker
                :label="$t('Facilitator_Backup')"
                :user="moc.roles.facilitatorBackup"
                :inUser="moc.roles.facilitatorBackup"
                readonly
              ></people-picker>
            </v-col>
          </v-row>
        </template>

        <!-- sent back status -->
        <template v-if="!readonly && formStatusSentBack">
          <v-form ref="facilitatorForm" autocomplete="off">
            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator')"
                  :user="moc.roles.facilitator"
                  :inUser="moc.roles.facilitator"
                  readonly
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator_Backup')"
                  :user="moc.roles.facilitatorBackup"
                  :inUser="moc.roles.facilitatorBackup"
                  readonly
                ></people-picker>
              </v-col>
            </v-row>
            <v-row>
              <void :moc="moc" role="facilitator"></void>
            </v-row>
          </v-form>
        </template>

        <!-- Submitted & Available for Decision -->
        <template v-if="!readonly && (formStatusSubmitted || formStatusAvailableForDecision)">
          <v-form ref="facilitatorForm" autocomplete="off">
            <v-row>
              <v-col cols="12" sm="10">
                <v-autocomplete
                  :model-value="approvalProcessType"
                  :label="$t('Select_Approval_Process_Type')"
                  :items="approvalProcessTypes"
                  :filter="customFilter"
                  item-title="name"
                  item-value="id"
                  :readonly="readonly || !formStatusSubmitted || isMakePermanent"
                  ref="approvalProcessType"
                  return-object
                  variant="underlined"
                  v-on:update:model-value="updateAPT($event)"
                  :menu-props="{ auto: true }"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Owner')"
                  :user="owner"
                  :inUser="owner"
                  :readonly="readonly || isMakePermanent"
                  name="owner"
                  @clear="moc.roles.owner = moc.approvalProcessType ? moc.approvalProcessType.owner : {}"
                  v-on:update:model-value="updateOwner($event)"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Coordinator')"
                  :user="coordinator"
                  :inUser="coordinator"
                  name="coordinator"
                  :readonly="coordinatorReadOnly"
                  :rules="coordinatorRules"
                  @clear="moc.roles.coordinator = {}"
                  v-on:update:model-value="updateCoordinator($event)"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator')"
                  :user="facilitator"
                  :inUser="facilitator"
                  name="facilitator"
                  :readonly="readonly || isMakePermanent"
                  :rules="facilitatorRules"
                  @clear="moc.roles.facilitator = {}"
                  v-on:update:model-value="updateFacilitator($event)"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator_Backup')"
                  :user="facilitatorBackup"
                  :inUser="facilitatorBackup"
                  name="facilitatorBackup"
                  :readonly="readonly || isMakePermanent"
                  :rules="backupFacilitatorRules"
                  @clear="moc.roles.facilitatorBackup = {}"
                  v-on:update:model-value="updateFacilitatorBackup($event)"
                ></people-picker>
              </v-col>
            </v-row>
          </v-form>

          <template v-if="!readonly">
            <v-row>
              <v-col cols="12" sm="9">
                <v-row dense justify="start">
                  <template v-if="canSendBack">
                    <v-dialog v-model="sendBackDialog" persistent max-width="600px">
                      <template v-slot:activator="{ props: activatorProps }">
                        <v-btn v-bind="activatorProps" color="accent" v-if="formStatusSubmitted" class="mx-2 mb-2">
                          <span style="color: white !important;">{{$t('Send_Back')}}</span>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-toolbar color="warning" dense>
                          <v-spacer></v-spacer>
                          <v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                        </v-toolbar>
                        <v-card-text class="text-h6 font-weight-bold">{{ $t('Reason_For_Send_Back') }}</v-card-text>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="10">
                                <v-form ref="sendBackMo" v-model="valid" autocomplete="off">
                                  <v-textarea
                                    v-model.trim="sentBackReason"
                                    name="sentBackReason"
                                    :rules="sentBackRules"
                                    variant="underlined"
                                    label="Reason"
                                    auto-grow
                                  ></v-textarea>
                                </v-form>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text class="card-button" @click="sendBackDialog = false">{{ $t('Cancel') }}</v-btn>
                          <v-btn color="primary" text class="card-button" @click="sendBack()">{{ $t('Save_Send_Back') }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>

                  <v-btn color="success" @click="save()" class="mx-2 mb-2">{{ $t('Save') }}</v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3">
                <v-row dense justify="end">
                  <v-btn
                    color="success"
                    @click="checkOwnerIsNotApprover()"
                    :disabled="!canSendForDecision"
                    v-if="formStatusSubmitted"
                    class="mx-2 mb-2"
                  >
                    {{ $t('Send_Decision') }}
                  </v-btn>

                  <v-dialog v-model="sendForOwnerDecisionDialog" persistent max-width="600px">
                    <template v-slot:activator="{ props: activatorProps }">
                      <v-btn
                        v-bind="activatorProps"
                        color="success"
                        :disabled="!canSendForOwnerDecision"
                        v-if="formStatusAvailableForDecision"
                        class="mx-2 mb-2"
                      >
                        {{ $t('Send_Owner_Decision') }}
                      </v-btn>
                    </template>

                    <v-card>
                      <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                      <v-card-text>
                        {{ $t('Notification_ReduceApproverTime') }}
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" class="card-button" text @click="sendForOwnerDecisionDialog = false">{{
                          $t('Owner_Did_Not_Agree')
                        }}</v-btn>
                        <v-btn color="primary" class="card-button" text @click="submitPendingOwnerDecision()">{{
                          $t('Owner_Agreed')
                        }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </template>


        <!-- Pending Owner Decision -->
        <template v-if="!readonly && formStatusPendingOwnerDecision">
          <v-form ref="facilitatorForm" autocomplete="off">
            <v-row>
              <v-col cols="12" sm="10">
                <v-autocomplete
                  :model-value="approvalProcessType"
                  :label="$t('Select_Approval_Process_Type')"
                  :items="approvalProcessTypes"
                  :filter="customFilter"
                  item-title="name"
                  item-value="id"
                  readonly
                  variant="underlined"
                  ref="approvalProcessType"
                  return-object
                  v-on:update:model-value="updateAPT($event)"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                
                <people-picker
                  :label="$t('Owner')"
                  :user="owner"
                  :inUser="owner"
                  name="owner"
                  :readonly="isMakePermanent"
                  @clear="moc.roles.owner = moc.approvalProcessType ? moc.approvalProcessType.owner : {}"
                  v-on:update:model-value="updateOwner($event)"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Coordinator')"
                  :user="coordinator"
                  :inUser="coordinator"
                  name="coordinator"
                  :readonly="isMakePermanent"
                  :rules="coordinatorRules"
                  @clear="moc.roles.coordinator = {}"
                  v-on:update:model-value="updateCoordinator($event)"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator')"
                  :user="facilitator"
                  :inUser="facilitator"
                  name="facilitator"
                  :readonly="isMakePermanent"
                  :rules="facilitatorRules"
                  @clear="moc.roles.facilitator = {}"
                  v-on:update:model-value="updateFacilitator($event)"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator_Backup')"
                  :user="facilitatorBackup"
                  :inUser="facilitatorBackup"
                  name="facilitatorBackup"
                  :readonly="isMakePermanent"
                  :rules="backupFacilitatorRules"
                  @clear="moc.roles.facilitatorBackup = {}"
                  v-on:update:model-value="updateFacilitatorBackup($event)"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row dense justify="start">
              <v-col cols="12">
                <v-btn color="success" @click="save()" class="mx-2">{{ $t('Save') }}</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </template>

        <!-- Being Implemented -->
        <template
          v-if="!readonly && (formStatusIsAvailableToImplement || formStatusChangeIsInPlaceWithConsequentialActionsRequired)"
        >
          <v-form ref="facilitatorForm" autocomplete="off">
            <v-row>
              <v-col cols="12" sm="10">
                <v-autocomplete
                  :model-value="approvalProcessType"
                  :label="$t('Select_Approval_Process_Type')"
                  :items="approvalProcessTypes"
                  :filter="customFilter"
                  item-title="name"
                  item-value="id"
                  readonly
                  variant="underlined"
                  ref="approvalProcessType"
                  return-object
                  v-on:update:model-value="updateAPT($event)"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Owner')"
                  :user="owner"
                  :inUser="owner"
                  name="owner"
                  :readonly="isMakePermanent"
                  @clear="moc.roles.owner = moc.approvalProcessType ? moc.approvalProcessType.owner : {}"
                  v-on:update:model-value="updateOwner($event)"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Coordinator')"
                  :user="coordinator"
                  :inUser="coordinator"
                  name="coordinator"
                  :readonly="isMakePermanent"
                  :rules="coordinatorRules"
                  @clear="moc.roles.coordinator = {}"
                  v-on:update:model-value="updateCoordinator($event)"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator')"
                  :user="facilitator"
                  :inUser="facilitator"
                  :readonly="isMakePermanent"
                  name="facilitator"
                  :rules="facilitatorRules"
                  @clear="moc.roles.facilitator = {}"
                  v-on:update:model-value="updateFacilitator($event)"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator_Backup')"
                  :user="facilitatorBackup"
                  :inUser="facilitatorBackup"
                  name="facilitatorBackup"
                  :readonly="isMakePermanent"
                  :rules="backupFacilitatorRules"
                  @clear="moc.roles.facilitatorBackup = {}"
                  v-on:update:model-value="updateFacilitatorBackup($event)"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row dense justify="start">
              <v-col cols="12">
                <void :moc="moc" role="facilitator"></void>
                <v-btn color="success" @click="save()" class="mx-2">{{ $t('Save') }}</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </template>

        <!-- implemented Ready to Close -->
        <template v-if="readonly && formStatusChangeFullyImplemented">
          <v-form ref="facilitatorForm" autocomplete="off">
            <v-row>
              <v-col cols="12" sm="10" v-if="moc.approvalProcessType.name">
                <v-text-field
                  v-model="moc.approvalProcessType.name"
                  :label="$t('Approval_Process_Type')"
                  :readonly="true"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Owner')"
                  :user="moc.roles.owner"
                  :inUser="moc.roles.owner"
                  :readonly="true"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Coordinator')"
                  :user="moc.roles.coordinator"
                  :inUser="moc.roles.coordinator"
                  :readonly="true"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator')"
                  :user="moc.roles.facilitator"
                  :inUser="moc.roles.facilitator"
                  :readonly="true"
                ></people-picker>
              </v-col>

              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Facilitator_Backup')"
                  :user="moc.roles.facilitatorBackup"
                  :inUser="moc.roles.facilitatorBackup"
                  :readonly="true"
                ></people-picker>
              </v-col>
            </v-row>
            <template v-if="isFacilitator">
              <closer-actions :moc="moc" role="facilitator"></closer-actions>
            </template>
          </v-form>
        </template>
      </v-container>
    </v-card>

    <v-dialog v-model="showOwnerIsApproverDialog" persistent max-width="400">
      <v-card>
        <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card-text> {{ showOwnerIsApproverDialogMessage }} </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="sendForDecision()">{{ $t('OK') }}</v-btn>
                <v-btn color="primary" text @click="showOwnerIsApproverDialog = false">{{ $t('Cancel') }}</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import { mapState } from 'vuex'
import MOCService from '@/services/moc.service'
import { AdvanceType } from '@/common/systemTypes'
import CloserActions from '@/components/mocForm/CloserActions'
import Void from '@/components/mocForm/Void'
import Toaster from '@/components/Toaster'
import { arrayContainsUser } from '@/common/userFunctions'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
import { Flags } from '@/common/flags'
import validateMoveToPendingOwnerDecisionMixin from '@/mixins/validateMoveToPendingOwnerDecisionMixin'
import approvalService from '@/services/approval.service'

export default {
  name: 'FacilitatorActions',
  emits: ['selectedAPT', 
    'selectedCoordinator', 
    'selectedFacilitator', 
    'selectedFacilitatorBackup', 
    'selectedOwner'],
  components: {
    PeoplePicker,
    CloserActions,
    Void,
    Toaster,
    LoadingDialog
  },
  mixins: [validateMoveToPendingOwnerDecisionMixin],
  data: () => ({
    showOwnerIsApproverDialog: false,
    showOwnerIsApproverDialogMessage: '',
    sendBackDialog: false,
    sendForOwnerDecisionDialog: false,
    valid: false,
    sentBackReason: '',
    approvedCount: 0,
    allMandatoryVoted: false
  }),
  props: {
    approvalProcessType: {
      type: Object,
      default: null
    },
    approvalProcessTypes: {
      type: Array,
      default: null
    },
    roles: {
      type: Array,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    moc: {
      type: Object
    },
    mocOwner: {
      type: Object,
      default: null
    },
    areTasksCompleted: {
      type: Boolean
    },
    tasks: {
      type: Array
    },
    forceReadonly: {
      type: Boolean,
      default: false
    },
    tempAdditionalApprovers: {
      type: Array,
      default: null
    }
  },
  methods: {
    checkOwnerIsNotApprover: function () {
      if (
        (arrayContainsUser(this.moc.roles.approvers, this.moc.roles.owner) ||
          arrayContainsUser(this.moc.roles.additionalApprovers, this.moc.roles.owner)) &&
        this.moc.multiPassCurrentPass === 0
      ) {
        // the current owner is an already an additional approver
        this.showOwnerIsApproverDialogMessage = this.$t('Confirm_OwnerIsApproverSaving', {
          person: this.moc.roles.owner.displayName
        })
        this.showOwnerIsApproverDialog = true
      } else {
        this.sendForDecision()
      }
    },
    haveAllMandatoryApproversVoted: function () {
      approvalService
        .haveAllMandatoryApproversVoted(this.moc.mocId)
        .then((result) => {
          console.log(`haveAllMandatoryApproversApproved ${result}`)
          this.allMandatoryVoted = result
          //return result
        })
        .catch((e) => {
          this.loadingApprovals = false
        })
    },
    save: async function () {
      this.$refs.loadingDialog.show()
      const data = this.moc
      MOCService.save(data, AdvanceType.NONE)
        .then((result) => {
          if (result.success) {
            this.$refs.loadingDialog.hide({ redirect: true })
          } else {
            throw new Error(result.message)
          }
        })
        .catch((e) => {
          this.$refs.loadingDialog.error({
            metadata: 'save',
            error: e
          })
        })
    },
    sendBack: function () {
      if (this.$refs.sendBackMo.validate()) {
        this.moc.sentBackReason = {
          reason: this.sentBackReason,
          sentBackBy: this.user
        }
        this.moc.approvalProcessType = {}
        this.moc.roles.coordinator = {}
        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.REVISION)
          .then((result) => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.$refs.loadingDialog.hide({ message: this.$t('Success_SendBackSaved'), redirect: true })
          })
          .catch((e) => {
            this.$refs.loadingDialog.error({ metadata: 'sendBack', error: e, message: this.$t('Error_SentBack') })
          })
      }
    },
    sendForDecision: function () {
      if (this.$refs.facilitatorForm.validate()) {
        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.ADVANCE)
          .then((result) => {
            if (!result.success) {
              throw new Error(result.message)
            }
          })
          .then(() => {
            this.$refs.loadingDialog.hide({ message: this.$t('Success_SentForDecision'), redirect: true })
          })
          .catch((e) => {
            this.$refs.loadingDialog.error({ metadata: 'sendForDecision', error: e, message: this.$t('Error_SendForDecision') })
          })
      }
    },
    submitPendingOwnerDecision: async function () {
      this.$refs.loadingDialog.show()
      const data = this.moc
      MOCService.save(data, AdvanceType.ADVANCE)
        .then((result) => {
          if (!result.success) {
            throw new Error(result.message)
          }
        })
        .then(() => {
          this.$refs.loadingDialog.hide({ message: this.$t('Success_SentToPendingOwnerDecision'), redirect: true })
        })
        .catch((e) => {
          this.$refs.loadingDialog.error({
            metadata: 'submitPendingOwnerDecision',
            error: e,
            message: this.$t('Error_SubmitPendingOwnerDecision')
          })
        })
    },    
    updateAPT: function (value) {
      this.$emit('selectedAPT', value)
    },
    updateCoordinator: function (value) {
      this.$emit('selectedCoordinator', value)
    },
    updateFacilitator: function (value) {
      this.$emit('selectedFacilitator', value)
    },
    updateFacilitatorBackup: function (value) {
      this.$emit('selectedFacilitatorBackup', value)
    },
    updateOwner: function (value) {
      this.$emit('selectedOwner', value)
    },
    customFilter(item, queryText, itemText) {
      const textOne = itemText.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.toLowerCase().indexOf(searchText) === 0
    }
  },
  computed: {
    ...mapState('currentUser', ['user']),
    ...mapState('currentMoc', ['formColor']),
    approvalProcessTypeRules: {
      get: function () {
        return [(v) => !!v || this.$t('Rule_Required_ApprovalProcessType')]
      }
    },
    canSendForDecision: function () {
      let approvers = []
      let additionalApprovers = []

      if (this.moc.multiPassCurrentPass === 0) {
        approvers = this.moc.roles.approvers
        additionalApprovers = this.moc.roles.additionalApprovers
      } else {
        const pass = this.moc.approvalProcessType.multiPass.approvalPasses[this.moc.multiPassCurrentPass - 1]
        approvers = pass.approvers
        additionalApprovers = pass.additionalApprovers
      }

      const approverCount = approvers.length + additionalApprovers.length
      if (approverCount > 1) {
        if (
          (this.moc.roles.owner || {}).displayName &&
          (this.moc.roles.coordinator || {}).displayName &&
          (this.moc.approvalProcessType || {}).name &&
          (this.moc.roles.facilitator || {}).displayName &&
          approverCount > 0 &&
          this.areTasksCompleted
        ) {
          return true
        }
      } else {
        if (approvers.length === 1 && this.moc.roles.owner) {
          if (approvers[0].id === this.moc.roles.owner.id) {
            return false
          }
        }

        if (additionalApprovers.length === 1 && this.moc.roles.owner) {
          if (additionalApprovers[0].id === this.moc.roles.owner.id) {
            return false
          }
        }

        if (
          this.moc.roles.coordinator &&
          this.moc.roles.coordinator.displayName &&
          this.moc.approvalProcessType &&
          this.moc.approvalProcessType.name &&
          this.moc.roles.facilitator &&
          this.moc.roles.facilitator.displayName &&
          approverCount > 0 &&
          this.areTasksCompleted
        ) {
          return true
        }
      }
      return false
    },
    canSendForOwnerDecision: function () {
      if (
        this.canMoveToPendingOwnerDecision &&
        this.moc.roles.coordinator?.displayName &&
        this.moc.approvalProcessType.name &&
        this.moc.roles.facilitator?.displayName &&
        this.moc.roles.owner.displayName &&
        this.areTasksCompleted &&
        this.allMandatoryVoted
      ) {
        return true
      }
      return false
    },
    closedVoidReasonRules: {
      get: function () {
        return [(v) => !!v || this.$t('Rule_Require_VoidReason')]
      }
    },
    coordinator: function () {
      if (this.moc.roles.coordinator && this.moc.roles.coordinator.displayName) {
        return this.moc.roles.coordinator
      }
      return null
    },
    coordinatorReadOnly: function () {
      if (this.isMakePermanent) {
        return true
      }
      switch (this.mocFormStatus) {
        case FormStatus.properties[FormStatus.SUBMITTED].value: {
          if (
            this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value)
          ) {
            return false
          }
          break
        }
        case FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value: {
          if (
            this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value) ||
            this.roles.includes(Roles.properties[Roles.OWNER].value)
          ) {
            return false
          }
          break
        }
        default:
          return true
      }
      return true
    },
    coordinatorRules: {
      get: function () {
        return [(v) => !!v || this.$t('Rule_Required_Coordinator')]
      }
    },
    facilitator: function () {
      if (this.moc.roles.facilitator && this.moc.roles.facilitator.displayName) {
        return this.moc.roles.facilitator
      }
      return null
    },
    facilitatorBackup: function () {
      if (this.moc.roles.facilitatorBackup && this.moc.roles.facilitatorBackup.displayName) {
        return this.moc.roles.facilitatorBackup
      }
      return null
    },
    facilitatorRules: {
      get: function () {
        return [
          (v) => !!v || this.$t('Rule_Required_Facilitator'),
          (v) =>
            v && this.moc.roles.facilitatorBackup && v.id === this.moc.roles.facilitatorBackup.id
              ? this.$t('Rule_FacilitatorNotBackup')
              : true
        ]
      }
    },
    isFacilitator() {
      return (
        this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
        this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value)
      )
    },
    backupFacilitatorRules() {
      return [
        (v) =>
          this.moc.roles.facilitator && v && this.moc.roles.facilitator.id === v.id
            ? this.$t('Rule_BackupFacilitatorNotFacilitator')
            : true
      ]
    },
    backgroundColor() {
      if (this.readonly && this.formStatusChangeFullyImplemented && this.isFacilitator) {
        return 'backgroundEditable'
      }
      if (this.readonly) {
        return 'backgroundReadOnly'
      }
      return 'backgroundEditable'
    },
    canSendBack() {
      return !(this.moc.flags || []).includes('extend') && !(this.moc.flags || []).includes('multipass') && !this.isMakePermanent
    },
    formStatusAvailableForDecision: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value) {
        return true
      }
      return false
    },
    formStatusIsAvailableToImplement: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value) {
        return true
      }
      return false
    },
    formStatusChangeIsInPlaceWithConsequentialActionsRequired: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value) {
        return true
      }
      return false
    },
    formStatusDraft: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.DRAFT].value) {
        return true
      }
      return false
    },
    formStatusChangeFullyImplemented: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED].value) {
        return true
      }
      return false
    },
    formStatusNew: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.NEW].value) {
        return true
      }
      return false
    },
    formStatusPendingOwnerDecision: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) {
        return true
      }
      return false
    },
    formStatusSentBack: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value) {
        return true
      }
      return false
    },
    formStatusSubmitted: function () {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.SUBMITTED].value) {
        return true
      }
      return false
    },
    isMakePermanent() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.MAKEPERMANENT].key)
    },
    owner: function () {
      if (this.mocOwner) {
        return this.mocOwner
      }
      return null
    },
    sentBackRules: {
      get: function () {
        return [(v) => !!v.trim() || this.$t('Rule_Required_SendBackReason')]
      }
    },
    readonly: function () {
      if (this.forceReadonly) {
        return true
      }
      switch (this.mocFormStatus) {
        case FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value: {
          // shortcut if unauthorized expired
          if (this.moc.flags && this.moc.flags.includes('unauthorized')) {
            return true
          }

          if ((this.moc.flags || []).includes('ownereditablemakepermanent')) {
            return true
          }

          if (
            this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value)
          ) {
            return false
          }

          break
        }
        case FormStatus.properties[FormStatus.SUBMITTED].value:
        case FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value:
        case FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value:
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
        case FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value: {
          if (
            this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value)
          ) {
            return false
          }
          break
        }
        default:
          return true
      }
      return true
    }
  },
  mounted() {
    this.haveAllMandatoryApproversVoted()
  }
}
</script>

<style scoped></style>
